import React from 'react'
import './nosotros.css'
import lineas from './Imagenes/lineas.png'
import audifonos from './Imagenes/audifono.png'
import logoNegro from './Imagenes/logo-negro.png'
import lomejor from './Imagenes/lomejor.png'
import logoLaConsola from './Imagenes/logolaconsola.png'
import scroll from './Imagenes/scroll.png'
import alacran from './Imagenes/alacran.png'
import pc from './Imagenes/pc.png'
import { Link } from 'react-router-dom'

function HomeNosotros() {
  return (
    <>
      <div className='nosotros_container'>
        <div className="top_container">
          <img className="lines_img" src={lineas} alt="lineasLaConsola" />
          <img className="micro_img" src={audifonos} alt="audifonosLaConsola" />
          <div className="top_info_container">
            <h2>Nuestra Empresa</h2>
            <p>Somos una empresa ágil y dinámica, dedicada a ofrecerte los mejores productos tecnológicos. Nuestra empresa está compuesta por un equipo humano de profesionales con el objetivo de ofrecerte el mejor servicio. Te invitamos a ponerte en contacto con nuestro equipo y vivir la experiencia de:</p>
            <img className="blackLogo_img" src={logoNegro} alt="logoNegroLaConsola" />
          </div>
        </div>

        <div className="mid_container">
          {/* <img className="warrior_img" src={warrior} alt="" /> */}
          <div className="mid_info_container">
            <div className="mid_flex_info_container">
              <h2>Productos y servicios garantizados</h2>
              <p>Aportamos en la búsqueda de la mejor solución que se adapte a tus requerimientos, apoyados en las nuevas tendencias tecnológicas, todo esto con la garantía de productos y servicios certíficados nacional e internacionalmente para que podas vivir una experiencia única. </p>
              <img className="theBestProduct_img" src={lomejor} alt="lomejorLaConsola" />
            </div>
          </div>
        </div>

        <div className="bottom_container">
          <img className="blueConsola_img" src={logoLaConsola} alt="logoLaConsola" />
          <img className="product_img" src={scroll} alt="scrollLaConsola" />
          <Link to="/"><div className="moreProducts">Descubrí productos</div></Link>
          <div className="bottom_info_container">
            <div className="left_info_container" data-aos="fade-right">
              <img className="insectPc_img" src={alacran} alt="alacranLaConsola" />
            </div>
            <div className="right_info_container">
              <h2 id="bestForClient2"> <a
                href="https://www.google.com/maps/place/La+Consola+Digital/@-32.9823539,-68.7923399,17z/data=!4m12!1m6!3m5!1s0x967e0cbe515a7533:0xe1b0585e6e8dbe2c!2sLa+Consola+Digital!8m2!3d-32.9823539!4d-68.7901512!3m4!1s0x967e0cbe515a7533:0xe1b0585e6e8dbe2c!8m2!3d-32.9823539!4d-68.7901512"
                target="_blank"
              >Nuestra Tienda</a></h2>
              <p id="text3">Acercate a nuestra tienda y viví la mejor experiencia tecnológica de toda Mendoza. Donde encontrarás todo para tu PC gamer, juegos, consolas, gadgets y servicio técnico certificado</p>
              <Link to="/ArmaTuPc"><img id="pcGamer" src={pc} alt="PcGamerLaConsola"/></Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeNosotros